import React from 'react';
import styled from 'styled-components';
import { Trans } from "react-i18next";
import { compose } from 'recompose';
import { Helmet } from "react-helmet";

import ContactForm from '../forms/ContactForm';
import {Icon, LinkTag, MailLink, Text} from '../common';

import { getScreenSize, getThemeColor, getThemeFont, getThemeSize } from '../../../utils/theme';
import { withLanguageOnChange } from '../../../utils/enhancers/withLanguageChange';
import withGATracker from '../../../utils/enhancers/withGATracker';

import EmailIcon from  '../../assets/imgs/icons/Email_Icon.svg';
import FacebookIcon from  '../../assets/imgs/icons/Facebook_Icon.svg';
import TopBackgroundUrl from '../../assets/imgs/Home_Top-img.svg';

const ContentCoverS = styled.div`
    background: url(${TopBackgroundUrl}) no-repeat center/cover;
    width: 100%;
    height: 100vh;
    margin-top: -60px;
`

const ContentWrapS = styled.div`
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  flex-wrap: wrap;
  margin: -70vh auto 150px;
  
  max-width: 1170px;
  width: 100%;
 
  @media (max-width: ${getScreenSize(['tabletPC'])}) {
    padding: 0 15px;
  }
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    justify-content:center;
  }
`;

const ContactFormWrapS = styled.div`
  max-width: 580px;
  flex: 0 0 580px;
  
  @media (max-width: ${getScreenSize(['tabletPC'])}) {
   flex: 0 0 40%;
   max-width: 40%;
  }
  
  @media (max-width: ${getScreenSize(['medium'])}) {
   flex: 0 0 auto;
   max-width: 100%;
   width: 100%;
  }
`

const ContactsInfo = styled.div`
  flex: 0 0 370px;
  max-width: 370px;
  display:flex;
  align-items:flex-start;
  flex-direction: column;
  margin-right: 50px;
  @media (max-width: ${getScreenSize(['tabletPC'])}) {
    flex: 0 0 320px;
    max-width: 320px;
    margin-right: 30px;
  }
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-right: 0;
  }
`;

const TitleText = styled(Text)`
  text-align: left;
  font-size: ${getThemeSize(['headers', 'secondary'])};
  color: ${getThemeColor(['violet'])};
  line-height: 1.3;
  text-transform: uppercase;
`;

const DescText = styled(Text)`
  text-align: left;
  font-size: ${getThemeSize(['bigText'])};
  color: ${getThemeColor(['black'])};
  line-height: 1.5;
  margin: 20px 0;
`

const ContactsInfoItems = styled.div`
  display:flex;
  align-items:flex-start;
  flex-direction: column;
  margin-bottom: 25px;
  
  @media (max-width: ${getScreenSize(['medium'])}) {
     margin-bottom: 20px;
     width: 90%;
     justify-content: center;
  }
`;

const ContactsInfoItem = styled.div`
  margin-bottom: 20px;
`

const ContactsInfoItemWr = styled.div`
  display:flex;
  align-items:center;
`

const ContactsInfoItemName = styled.p`
  font-family: ${getThemeFont(['bold'])};
  font-size: ${getThemeSize(['bigText'])};
  color: ${getThemeColor(['violet'])};
  margin-top: 0;
  margin-bottom: 10px;
`

const ContactsInfoItemDesc = styled.div`
  display:flex;
  align-items:center;
  font-size: ${getThemeSize(['bigText'])};
  color: ${getThemeColor(['darkerViolet'])};
  img {
    margin-right: 10px;
  }
`

const ContactsComponent = () => (
  <>
      <Helmet>
        <title>Treuhand-suche.ch: Kontakte</title>
        <meta name="description" content="Treuhand-suche.ch: Kontakte" />
        <meta property="og:title" content="Treuhand-suche.ch: Kontakte"  />
        <meta property="og:description" content="Treuhand-suche.ch: Kontakte"  />
        <meta property="og:url" content="https://treuhand-suche.ch/contacts"  />
      </Helmet>

      <ContentCoverS />

      <ContentWrapS>
        <ContactsInfo >
          <TitleText>
            <Trans i18nKey='contactsPage.contactTitle1' />
            <br/>
            <Trans i18nKey='contactsPage.contactTitle2' />
          </TitleText>

          <DescText>
            <Trans i18nKey='contactsPage.contactDesc' />
          </DescText>

          <ContactsInfoItems>

            <ContactsInfoItem>
              <ContactsInfoItemName>
                <Trans i18nKey='contactsPage.email' />
              </ContactsInfoItemName>
              <ContactsInfoItemWr>
                <MailLink email='admin@treuhand-suche.ch' content={
                  <ContactsInfoItemDesc><Icon src={EmailIcon}/> admin@treuhand-suche.ch </ContactsInfoItemDesc>
                } />
              </ContactsInfoItemWr>

            </ContactsInfoItem>

            <ContactsInfoItem>
              <ContactsInfoItemName>
                <Trans i18nKey='contactsPage.socialMedia' />
              </ContactsInfoItemName>
              <ContactsInfoItemWr>
                <LinkTag
                  href="https://www.facebook.com/Treuhand-suchech-2059437657690758/"
                  content={
                    <ContactsInfoItemDesc><Icon src={FacebookIcon}/><Trans i18nKey='contactsPage.socialMediaFacebook' /></ContactsInfoItemDesc>
                  }
                />
              </ContactsInfoItemWr>
            </ContactsInfoItem>

          </ContactsInfoItems>
        </ContactsInfo>

        <ContactFormWrapS>
            <ContactForm />
        </ContactFormWrapS>
      </ContentWrapS>
  </>
);


export default compose(withLanguageOnChange, withGATracker)(ContactsComponent);
